<template>
	<el-tabs v-model="activeName" type="card">
		<el-tab-pane label="User Information" name="first">
			<el-row>
				<el-col :span="24">
					<el-form :inline="true" :model="filters" label-width="180px">
						<el-form-item label="User Name">
							<el-input v-model="filters.sName" placeholder=""></el-input>
						</el-form-item>
						<el-form-item label="Status">
							<el-select v-model="filters.sState" placeholder="">
								<el-option
									v-for="item in options"
									:key="item.id"
									:label="item.name"
									:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="reGetList">Search</el-button>
							<el-button type="primary" v-on:click="addUserFlag = true">
								Add User
							</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="24">
					<el-table
						ref="multipleTable"
						:data="tableData"
						tooltip-effect="dark"
						style="width: 100%"
						@selection-change="handleSelectionChange"
					>
						<el-table-column type="selection"></el-table-column>
						<el-table-column prop="nUserId" label="User Id"></el-table-column>
						<el-table-column prop="sAccount" label="Domain Account"></el-table-column>
						<el-table-column prop="sName" label="User Name"></el-table-column>
						<el-table-column prop="sRole" label="Role"></el-table-column>
						<el-table-column
							prop="sState"
							label="Status"
							:formatter="sState"
						></el-table-column>
						<el-table-column prop="dLastLogin" label="Last Sign in"></el-table-column>
					</el-table>
				</el-col>
				<el-col :span="24">
					<div style="margin-top:20px;float: left;" v-if="tableData3.length > 0">
						<el-button @click="toggleSelection(0)" v-if="filters.sState == 1">
							Inactive
						</el-button>
						<el-button @click="toggleSelection(1)" v-if="filters.sState == 0">
							Active
						</el-button>
					</div>
					<div style="float: right;margin-top:20px;">
						<el-pagination
							@current-change="handleCurrentChange"
							background
							layout="prev, pager, next"
							:total="total"
						></el-pagination>
					</div>
				</el-col>
			</el-row>
			<el-dialog title="Add User" :visible.sync="addUserFlag" width="50%">
				<el-form :model="form" ref="form" label-width="160px">
					<el-form-item label="User Name" prop="sName">
						<el-input v-model="form.sName" placeholder=""></el-input>
					</el-form-item>
					<el-form-item label="Domain Account" prop="sAccount">
						<el-input v-model="form.sAccount" placeholder=""></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="addUserFlag = false">Cancel</el-button>
					<el-button type="primary" @click="save">Confirm</el-button>
				</span>
			</el-dialog>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import { getUserInfoList, updateUserInfo, addUserInfo } from '../../api/api';
export default {
	data() {
		return {
			addUserFlag: false,
			activeName: 'first',
			form: {
				sName: '',
				sAccount: ''
			},
			options: [
				{
					id: '1',
					name: 'Active'
				},
				{
					id: '0',
					name: 'Inactive'
				}
			],
			filters: {
				sName: '',
				sState: '1',
				pageSize: 10,
				currentPage: 1
			},
			total: 0,
			tableData3: [],
			tableData: []
		};
	},
	mounted() {
		this.getList();
	},
	methods: {
		save() {
			if (!this.form.sName) {
				this.$message.error('Please enter the user name');
				return;
			}
			if (!this.form.sAccount) {
				this.$message.error('Please enter the domain account ');
				return;
			}
			addUserInfo(this.form).then(res => {
				this.$refs.form.resetFields();
				this.reGetList();
				this.$message('Add Success');
				this.addUserFlag = false;
			});
		},
		sState(data) {
			for (var i = 0; i < this.options.length; i++) {
				if (this.options[i]['id'] == data.sState) {
					return this.options[i]['name'];
				}
			}
		},
		toggleSelection(sState) {
			var arr = [];
			for (var i = 0; i < this.tableData3.length; i++) {
				arr.push(this.tableData3[i]['nUserId']);
			}
			var _this = this;
			this.$confirm('Confirm to ' + (sState == 1 ? 'Active' : 'Inactive') + '?', 'Tips', {
				type: 'warning',
				customClass: 'customConfimClass'
			})
				.then(() => {
					updateUserInfo({
						nUserIds: arr,
						sState: sState
					}).then(res => {
						_this.reGetList();
					});
				})
				.catch(() => {});
		},
		handleSelectionChange(val) {
			this.tableData3 = val;
		},
		handleCurrentChange(page) {
			this.filters.currentPage = page;
			this.getList();
		},
		reGetList: function() {
			this.filters.currentPage = 1;
			this.getList();
		},
		getList: function() {
			var param = Object.assign({}, this.filters);
			getUserInfoList(param).then(res => {
				this.tableData = res.data;
				this.total = res.page.totalCount * 1;
			});
		}
	}
};
</script>

<style></style>



// WEBPACK FOOTER //
// user.vue?6c59f704